module.exports = __webpack_public_path__ + "img/Sources-icon.b95856e1.svg";